import { create } from "zustand";
import { AnamnestidData } from "../api-objects/anamnestic-data";

interface EmrState {
    anamnesticData: AnamnestidData[] | null,
    groupedAnamnesticData: Record<string, AnamnestidData[]> | null;
}

interface EmrStore {
    emrs: EmrState;
    updateEmrs: (updates: Partial<EmrState>) => void;
    clearEmrs: () => void;
}

export const useEmrStore = create<EmrStore>((set) => ({
    emrs: JSON.parse(localStorage.getItem("emrs") || "{}") as EmrState || {
        anamnesticData: null,
        groupedAnamnesticData: null,
    },

    updateEmrs: (updates) => {
        set((state) => {
            const newEmrs = { ...state.emrs, ...updates };
            // Group the data if anamnesticData exists and has changed
            if (newEmrs.anamnesticData) {
                const grouped = newEmrs.anamnesticData.reduce<Record<string, AnamnestidData[]>>(
                    (acc, data) => {
                        const key = data.data.key;  // Assuming the 'key' is used for grouping
                        if (!acc[key]) {
                            acc[key] = [];
                        }
                        acc[key].push(data);
                        return acc;
                    },
                    {}
                );
                newEmrs.groupedAnamnesticData = grouped;
            }
            localStorage.setItem("emrs", JSON.stringify(newEmrs));
            return { emrs: newEmrs };
        });
    },

    clearEmrs: () => {
        set({ emrs: { anamnesticData: null, groupedAnamnesticData: null } });
        localStorage.removeItem("emrs");
    },
}))
